<template>
  <div class="asc-doc-mgmt-wrapper">
    <asc-side-navigation
      v-model="tab"
      :side-items="tabs"
      :show-link="false"
      class="asc-doc-mgmt-wrapper--side-nav"
    >
      <asc-tab-body
        :value="tab"
        no-padding
        class="asc-doc-mgmt-wrapper-tab-body"
      >
        <asc-tab-item>
          <asc-doc-mgmt-help-about-wrapper
            :values="helpAboutGridData"
            :contents="helpAboutContents"
            :user="user"
            :deselect-all-user-guides="deselectAllUserGuides"
            :grid-disabled="helpAboutGridDisabled"
            v-on="$listeners"
          />
        </asc-tab-item>
        <asc-tab-item v-for="tabItem in getInActiveTabs" :key="tabItem.id">
          <asc-page-coming-soon
            :label="getLabel(tabItem.title)"
          ></asc-page-coming-soon>
        </asc-tab-item>
      </asc-tab-body>
    </asc-side-navigation>
  </div>
</template>

<script>
import AscTabBody from '@/components/atoms/AscTabBody'
import AscTabItem from '@/components/atoms/AscTabItem'
import AscSideNavigation from '@/components/molecules/AscSideNavigation'
import AscPageComingSoon from '@/components/molecules/AscPageComingSoon'
import AscDocMgmtHelpAboutWrapper from '@/components/organisms/AscDocMgmtHelpAboutWrapper'

export default {
  name: 'AscDocMgmtWrapper',

  components: {
    AscTabBody,
    AscTabItem,
    AscSideNavigation,
    AscPageComingSoon,
    AscDocMgmtHelpAboutWrapper,
  },

  props: {
    tabs: {
      type: Array,
      required: true,
    },
    user: {
      type: Object,
      default: () => {},
    },
    // help & About
    helpAboutGridData: {
      type: Array,
      required: true,
      default: () => [],
    },
    helpAboutGridDisabled: {
      type: Boolean,
      default: false,
    },
    helpAboutContents: {
      type: Array,
      default: () => [],
    },
    deselectAllUserGuides: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      tab: 0,
      isUploadNewDocmentAvailable: true,
    }
  },

  computed: {
    getInActiveTabs() {
      return this.tabs.filter(value => {
        return !value.active
      })
    },
    getSideNavHeader() {
      return this.tabs && this.tabs[this.tab] && this.tabs[this.tab].headerText
        ? this.tabs[this.tab].headerText
        : null
    },
  },

  methods: {
    getLabel(title) {
      return `[${title} Update Form]`
    },
  },
}
</script>

<style lang="scss">
.asc-doc-mgmt-wrapper {
  &--header {
    height: 62px;
    color: $primary-black;
    text-transform: uppercase;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 1px;
    line-height: 18px;
    padding: 15px 16px;
    border-bottom: 1px solid $gray-300;
    background-color: $primary-white;
  }

  &--side-nav {
    .asc-doc-mgmt-wrapper-tab-body {
      width: 100%;
    }

    .asc-doc-mgmt-wrapper-side-nav > div > div > div {
      height: 100%;
    }
  }
}
</style>
